import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { representanteAPI } from '../../services/api';
import MisJugadores from './MisJugadores';
import RegistrarPago from './RegistrarPago';
import HistorialPagos from './HistorialPagos';

const tabs = [
  { id: 'jugadores', label: 'Mis Jugadores', icon: '⚽' },
  { id: 'pago', label: 'Registrar Pago', icon: '💳' },
  { id: 'historial', label: 'Historial', icon: '📋' },
];

const RepresentanteDashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const rep = user?.representante;

  const [activeTab, setActiveTab] = useState('jugadores');
  const [jugadores, setJugadores] = useState([]);
  const [representanteId, setRepresentanteId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        const response = await representanteAPI.getMisJugadores();
        setJugadores(response.data.jugadores || []);
        setRepresentanteId(response.data.representante_id);
      } catch (error) {
        console.error('Error loading jugadores:', error);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login?tipo=representante');
  };

  const handlePagoRegistrado = () => {
    // Switch to history tab after successful payment
    setActiveTab('historial');
  };

  return (
    <div className="min-h-screen bg-gray-100 pb-20">
      {/* Header */}
      <header className="bg-gradient-to-r from-lsfc-green-600 to-lsfc-green-700 text-white p-4 shadow-lg">
        <div className="max-w-lg mx-auto flex justify-between items-center">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
              <span className="text-lg">{rep?.tipo === 'madre' ? '👩' : '👨'}</span>
            </div>
            <div>
              <h1 className="text-sm font-bold leading-tight">
                {rep?.nombre} {rep?.apellido}
              </h1>
              <p className="text-xs text-green-200">Los Salias FC</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="px-3 py-1.5 bg-white/20 text-white rounded-lg text-xs hover:bg-white/30 transition-colors"
          >
            Salir
          </button>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-lg mx-auto p-4">
        {activeTab === 'jugadores' && (
          <MisJugadores jugadores={jugadores} loading={loading} />
        )}
        {activeTab === 'pago' && (
          <RegistrarPago
            jugadores={jugadores}
            representanteId={representanteId}
            onPagoRegistrado={handlePagoRegistrado}
          />
        )}
        {activeTab === 'historial' && (
          <HistorialPagos representanteId={representanteId} />
        )}
      </main>

      {/* Bottom tab navigation */}
      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
        <div className="max-w-lg mx-auto flex">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex-1 py-3 flex flex-col items-center gap-0.5 transition-colors ${
                activeTab === tab.id
                  ? 'text-lsfc-green-600 bg-green-50'
                  : 'text-gray-400 hover:text-gray-600'
              }`}
            >
              <span className="text-xl">{tab.icon}</span>
              <span className="text-xs font-medium">{tab.label}</span>
            </button>
          ))}
        </div>
      </nav>
    </div>
  );
};

export default RepresentanteDashboard;
